// extracted by mini-css-extract-plugin
export default {"writingPractice":"writingPractice-AYY1t","modalHeader":"modalHeader-mikuX","modalTitle":"modalTitle-qyRoZ","body":"body-FoZ0S"};